import './CSS/navBar.css'

import discord from './assets/discordcircle.png'
import twitter from './assets/twittercircle.png'
import openSea from './assets/opensea.png'

import { NavLink } from 'react-router-dom'
import { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'


function NavBar({ isConnected, openConnectModal, isMobile }) {

    const SocialLinks = () => {
        return (
            <>
                <a href='https://discord.gg/BdfcmcNqxp' target='_blank' rel='noreferrer'>
                    <div className="iconContainer">
                        <img className="icon" src={discord} alt="Discord logo" />
                    </div>
                </a>

                <a href='https://twitter.com/RedactedBBCNFT' target='_blank' rel='noreferrer'>
                    <div className="iconContainer">
                        <img className="icon" src={twitter} alt="Twitter logo" />
                    </div>
                </a>

                <a href='https://opensea.com' target='_blank' rel='noreferrer'>
                    <div className="iconContainer">
                        <img className="icon" src={openSea} alt="Opensea logo" />
                    </div>
                </a>
            </>
        )
    }

    const [menuOpen, setMenuOpen] = useState(false)

    return (
        <>
            {isMobile ? (
                <>
                    {menuOpen ? (
                        <div className='menuContainer'>
                            <div className='menuSection'>
                                <SocialLinks />
                            </div>
                            <div className='menuSection'>
                                <div className='navLinksContainer'>
                                    <NavLink to='/'><button className="navLink">Mint</button></NavLink>
                                    <NavLink to='/claim'><button className="navLink">Claim</button></NavLink>
                                    <NavLink to='/team'><button className="navLink">Team</button></NavLink>
                                </div>
                            </div>
                            <div className='menuSection'>
                                {isConnected ?
                                    (
                                        <div className="connectButtonInactive">Connected</div>
                                    ) : (
                                        <button className="connectButton" onClick={openConnectModal}>Connect</button>
                                    )
                                }
                            </div>
                        </div>
                    ) : (
                        <></>
                    )}

                    <button className='menuBar' onClick={() => setMenuOpen(!menuOpen)}>
                        <h1>Menu</h1>
                    </button>
                </>

            ) : (
                <nav className="navBarContainer">

                    <div className="section">
                        <SocialLinks />
                    </div>

                    <div className="section middle">
                        <div className="navLinksContainer">
                            <NavLink to='/'><div className="navLink">Mint</div></NavLink>
                            <NavLink to='/claim'><div className="navLink">Claim</div></NavLink>
                            <NavLink to='/team'><div className="navLink">Team</div></NavLink>
                        </div>
                    </div>

                    <div className="section right">
                        {isConnected ?
                            (
                                <button className="connectButtonInactive">Connected</button>
                            ) : (
                                <button className="connectButton" onClick={openConnectModal}>Connect</button>
                            )
                        }
                    </div>

                </nav>
            )
            }
        </>
    )
}

export default NavBar